'use strict';

exports.__esModule = true;
// Generated by CoffeeScript 1.12.6
var createSubscription;

exports.default = createSubscription = function (observer, unsubscriber) {
  var subscription;
  subscription = {
    unsubscribe: function () {
      if (observer) {
        observer = void 0;
        return unsubscriber();
      }
    }
  };
  return Object.defineProperty(subscription, 'closed', {
    configurable: true,
    enumerable: true,
    get: function () {
      return observer == null;
    }
  });
};